import {
  AlignmentType,
  Footer,
  Header,
  PageNumber,
  Paragraph,
  TextRun,
} from "docx";

export const styles_izrastzoff = {
  companyId: ["12401", "12407"],
  companyName: "Izrastzoff",
  font: "Times New Roman",
  titleSize: 21,
  textSize: 20,
  lineSpacing: 310,
  marginRight: 880,
  marginLeft: 880,
  beforeParagraph: 300,

  header: new Header({
    children: [
      new Paragraph({
        spacing: {
          before: 0,
          after: 450,
        },
        alignment: AlignmentType.CENTER,
      }),
    ],
  }),

  footer: new Footer({
    children: [
      new Paragraph({
        spacing: {
          before: 300,
          after: 0,
        },
        alignment: AlignmentType.CENTER,
      }),
      new Paragraph({
        alignment: AlignmentType.RIGHT,
        children: [
          new TextRun({
            children: [PageNumber.CURRENT],
          }),
        ],
      }),
    ],
  }),
};
